const POPUP_ANIMATION_END_DURATION = 500;
const POPUP_SUCCESS_DISPLAY_DURATION = 2000;

export const POPUP_CONSTANT = {
  POPUP_ANIMATION_END_DURATION,
  POPUP_SUCCESS_DISPLAY_DURATION,
} as const;
